import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { STEPPER_ORDER_BOOK } from '../../../../utils/constants'

// Finished steps can be clicked to go back to them; your draft is saved as you go
const Stepper = ({ currentStep, orderUrlData = {} }) => {
  const navigate = useNavigate()
  // Without online checkout, the last step asks the Morsel team for the book
  const selfServe = useSelector((state) => !!state.user?.data?.cookbook_self_serve)

  return (
    <ol className="cbStepper">
      {STEPPER_ORDER_BOOK.map(({ step, name: label }) => {
        const name = step === 5 && !selfServe ? 'Ship & request' : label
        const done = step < currentStep
        const current = step === currentStep
        const canGo = done && (step === 1 || orderUrlData.orderId)

        return (
          <li
            key={step}
            className={`cbStepperItem ${done ? 'done' : ''} ${current ? 'current' : ''}`}
          >
            <button
              type="button"
              className="cbStepperButton"
              disabled={!canGo}
              aria-current={current ? 'step' : undefined}
              aria-label={`Step ${step}: ${name}${done ? ' (done)' : ''}`}
              onClick={() => navigate('.', { state: { ...orderUrlData, currentStep: step } })}
            >
              <span className="cbStepperNumber">{done ? '✓' : step}</span>
              <span className="cbStepperName">{name}</span>
            </button>
          </li>
        )
      })}
    </ol>
  )
}

export default Stepper
